import { type FaceKey, resolvedFacePhotoSchema } from '@repo/api-contracts';
import { usePhotoDraftStore } from '@/entities/edit-area';
import { type FaceAssetUpload, useFaceAssetUpload } from './use-face-asset-upload';

/** 색상·면 카드당 전송 하나. 성공 전까지 기존 사진을 유지하고 취소된 응답은 상태에 전달하지 않는다. */
export const useFacePhotoUpload = (colorOptionId: string, face: FaceKey): FaceAssetUpload => {
  const store = usePhotoDraftStore();
  return useFaceAssetUpload({
    store,
    slot: `${colorOptionId}:${face}`,
    purpose: 'EDIT_FACE_PHOTO',
    contentTypeMessage: 'PNG·JPEG·WebP 형식만 업로드할 수 있습니다.',
    label: '사진',
    isSlotAlive: (state) =>
      state.draft.activeFaces.includes(face) &&
      state.draft.colors.some((color) => color.colorOptionId === colorOptionId),
    begin: (operationId) => store.getState().beginOperation(colorOptionId, face, operationId),
    setStatus: (operationId, status) =>
      store.getState().setOperationStatus(colorOptionId, face, operationId, status),
    cancel: (operationId) => store.getState().cancelOperation(colorOptionId, face, operationId),
    parseConfirmed: (result, productId) => {
      const parsed = resolvedFacePhotoSchema.safeParse(result);
      if (
        !parsed.success ||
        !result.photoKey.startsWith(`products/${productId.toLowerCase()}/faces/`)
      )
        return null;
      return { key: parsed.data.photoKey, size: parsed.data.photoSize, url: parsed.data.photoUrl };
    },
    reflect: (operationId, asset) =>
      store.getState().setPhoto({
        colorOptionId,
        face,
        operationId,
        photo: { photoKey: asset.key, photoSize: asset.size },
        photoUrl: asset.url,
      }),
  });
};
